import { Injectable, inject } from '@angular/core';
import {
  Router,
  CanActivate,
  CanMatch,
  Route,
  UrlSegment,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { UserService } from '@core/services/user.service';

@Injectable({ providedIn: 'root' })
export class LoggedGuard implements CanActivate, CanMatch {
  private router = inject(Router);
  private userService = inject(UserService);

  token: string;
  appId: string;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.appId = this.userService.getAppId();
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    if (this.toHaveAccess) {
      this.router.navigate(['tenant', this.appId, 'assets']);

      return false;
    }

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.toHaveAccess) {
      this.router.navigate(['tenant', this.appId, 'assets']);

      return false;
    }

    return true;
  }

  private get toHaveAccess(): boolean {
    let isLoggedIn;

    this.userService.isLoggedIn$.subscribe((res) => {
      isLoggedIn = res;
    });

    return isLoggedIn;
  }
}
